import type { PlatformType } from "./platform-type";

export class PlatformInfo {

    constructor(
        public platformType: PlatformType, 
        public uniqueId: string, 
        public model: string, 
        public macAddress: string) {
    }

};